import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MonthlyRecapToggle() {
  const { t } = useTranslation();
  const { user, refresh } = useAuth();
  const [on, setOn] = useState(user?.monthly_recap_enabled !== false);
  const [saving, setSaving] = useState(false);
  if (!(user?.tier === "premium" || user?.role === "admin")) return null;

  const change = async (v) => {
    setOn(v);
    setSaving(true);
    try {
      await api.put("/monthly-recap/preference", { enabled: v });
      await refresh();
      toast.success(v ? t("account.monthlyRecapOn") : t("account.monthlyRecapOff"));
    } catch {
      setOn(!v);
      toast.error(t("account.monthlyRecapError"));
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="account-monthly-recap" className="bg-white border border-slate-200 rounded-2xl p-8 flex items-start gap-4">
      <div className="w-10 h-10 rounded-xl bg-blue-100 text-blue-800 flex items-center justify-center shrink-0"><Mail size={18} /></div>
      <div className="flex-1 min-w-0">
        <div className="text-xs uppercase tracking-widest text-blue-800 font-semibold">{t("account.monthlyRecapTitle")}</div>
        <p className="mt-2 text-sm text-slate-600 max-w-lg">{t("account.monthlyRecapBody")}</p>
      </div>
      <Switch data-testid="account-monthly-recap-switch" checked={on} disabled={saving} onCheckedChange={change} />
    </div>
  );
}
